export const ru = {
    newAudience: 'Новая аудитория',
    newGroup: 'Новая группа'
};
